export default __webpack_public_path__ + "static/media/data_breach.a741677e.svg";